module.exports = __webpack_public_path__ + "img/check-2.f4475746.svg";